import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import * as statusActions from 'actions/statusActions';
import * as siteActions from 'actions/siteActions';

export class ArrivalTimeDialog extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancel = this
            .handleCancel
            .bind(this);
        this.handleSubmit = this
            .handleSubmit
            .bind(this);

        this.handleChangeHour = this
            .handleChangeHour
            .bind(this);

        this.handleChangeMintue = this
            .handleChangeMintue
            .bind(this);
    }

    componentDidMount() {

        const { statusActions, userId } = this.props;

        statusActions.setNextArrivalTime(this.nearestFutureMinutes(5, moment()).toDate(), userId);

    }

    componentWillReceiveProps(nextProps) {

        const { statusActions, techData, userId } = nextProps;
        const nextArrivalTime = techData.getIn(['techs', userId, 'arrivalTime', 'time']);

        if (!nextArrivalTime) {
            statusActions.setNextArrivalTime(this.nearestFutureMinutes(5, moment()).toDate(), userId);
        }
        if (techData.getIn(['techs', userId, 'arrivalTime', 'show']) && !techData.getIn(['techs', userId, 'arrivalTime', 'time'])) {
            statusActions.setNextArrivalTime(this.nearestFutureMinutes(5, moment()).toDate(), userId);
        }

    }

    handleChangeHour(e) {
        const { userId, techData } = this.props;

        let nextArrivalTime = moment(techData.getIn(['techs', userId, 'arrivalTime', 'time']));

        if (!nextArrivalTime.isValid()) {
            nextArrivalTime = this.nearestFutureMinutes(5, moment());
        }

        this.setTime(nextArrivalTime, e.target.value, nextArrivalTime.minutes());
    }

    setTime(nextArrivalTime, hour, minute) {
        const { statusActions, userId } = this.props;

        if (!nextArrivalTime.isValid()) {
            nextArrivalTime = this.nearestFutureMinutes(5, moment());
        }

        nextArrivalTime = nextArrivalTime
            .clone()
            .minute(minute)
            .hour(hour);

        if (nextArrivalTime.isBefore(moment())) {
            statusActions.setNextArrivalTime(this.nearestFutureMinutes(5, moment()).toDate(), userId);
        } else {

            statusActions.setNextArrivalTime(nextArrivalTime.toDate(), userId);
        }
    }

    handleChangeMintue(e) {
        const { userId, techData } = this.props;

        let nextArrivalTime = moment(techData.getIn(['techs', userId, 'arrivalTime', 'time']));

        if (!nextArrivalTime.isValid()) {
            nextArrivalTime = this.nearestFutureMinutes(5, moment());
        }

        this.setTime(nextArrivalTime, nextArrivalTime.hours(), e.target.value);
    }

    handleCancel() {
        const { siteActions, userId } = this.props;
        siteActions.hideArrivalTimeDialog(userId);
    }

    handleSubmit(e) {
        e.preventDefault();
        const { statusActions, workOrder, techData, userId, currentUserId } = this.props;

        const firstWorkOrderNumber = techData.getIn(['techs', userId, 'arrivalTime', 'orderId']);
        const nextArrivalTime = moment(techData.getIn(['techs', userId, 'arrivalTime', 'time']));
        const schedulingSystemDetails = workOrder.getIn(['workOrderDetails', firstWorkOrderNumber, 'schedulingSystemDetails', 'details']);
        const billingSystem = schedulingSystemDetails.getIn(['billingSystem']);
        const serviceType = schedulingSystemDetails.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
        const addressId = schedulingSystemDetails.getIn(['addressInfo', 'addressId']);

        const accountNumber = workOrder.getIn([
            'workOrderDetails',
            firstWorkOrderNumber,
            'customerDetails',
            'details',
            'accountNumber'
        ]);

        const customerTypeCode = workOrder.getIn([
            'workOrderDetails',
            firstWorkOrderNumber,
            'customerDetails',
            'details',
            'customerTypeCode'
        ]);

        const trackingUrl = workOrder.getIn([
            'workOrderDetails',
            firstWorkOrderNumber,
            'schedulingSystemDetails',
            'details',
            'serviceOrderInfoV2',
            'trackingURL'
        ]);

        if (firstWorkOrderNumber) {
            const channels = [userId];
            if (userId !== currentUserId) {
                channels.push(currentUserId);
            }
            const workOrderGoInRouteRequest = {
                techStatusChange: {
                    userId: userId,
                    techStatusWorkOrder: {
                        workOrderNumber: firstWorkOrderNumber,
                        arrivalTime: nextArrivalTime.format("h:mm A"),
                        billingSystem: billingSystem,
                        accountNumber: accountNumber,
                        customerTypeCode: customerTypeCode,
                        serviceType: serviceType,
                        addressId: addressId
                    },
                    techStatus: "Enroute",
                    trackingUrl: trackingUrl
                },
                channels: channels
            };

            statusActions.setTechStatusInRoute(workOrderGoInRouteRequest, userId);

        }
    }

    nearestFutureMinutes(interval, someMoment) {
        const roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval;
        return someMoment
            .clone()
            .minute(roundedMinutes)
            .second(0);
    }

    buildMinutes(nextArrivalTime, time) {

        const minutes = [];
        let minMinutes = time.minutes();

        if (nextArrivalTime.hours() > time.hours()) {
            minMinutes = 0;
        }

        for (let i = minMinutes; i < 60; i += 5) {
            let display = i;
            if (i <= 9) {
                display = '0' + i;
            }
            minutes.push(
                <option key={'minute' + i} value={i}>{display}</option>
            );
        }

        return minutes;

    }

    buildHours(time) {

        const hours = [];

        for (let i = time.hours(); i < 24; i += 1) {
            let display = i;
            if (i <= 9) {
                display = '0' + i;
            }

            if (i > 12) {

                const twelveHourFormat = i - 12;

                if (i <= 9) {
                    display = '0' + i;
                } else {
                    display = twelveHourFormat;

                    if (twelveHourFormat <= 9) {
                        display = '0' + twelveHourFormat;
                    }
                }
            }

            hours.push(
                <option key={'hour' + i} value={i}>{display}</option>
            );
        }

        return hours;

    }

    render() {

        const { techData, userId } = this.props;
        let currentTime = this.nearestFutureMinutes(5, moment());

        const nextArrivalTime = moment(techData.getIn(['techs', userId, 'arrivalTime', 'time']));

        if (nextArrivalTime) {
            currentTime = moment(nextArrivalTime);
        }

        const open = techData.getIn(['techs', userId, 'arrivalTime', 'show']) ? techData.getIn(['techs', userId, 'arrivalTime', 'show']) : false;

        let submitButton = (<RaisedButton
            key="ArrivalTimeSubmit"
            label="Submit"
            primary={true}
            disabled={false}
            onTouchTap={this.handleSubmit} />);

        let dialogBody = (
            <div>
                <span style={{
                    display: 'inline-block'
                }}>
                    <select
                        onChange={this.handleChangeHour}
                        className="browser-default"
                        value={currentTime.hours()}>
                        {this.buildHours(this.nearestFutureMinutes(5, moment()))}
                    </select>
                </span>
                <span style={{
                    display: 'inline-block'
                }}>
                    <select
                        onChange={this.handleChangeMintue}
                        className="browser-default"
                        value={currentTime.minutes()}>
                        {this.buildMinutes(nextArrivalTime, this.nearestFutureMinutes(5, moment()))}
                    </select>
                </span>
                <span style={{
                    display: 'inline-block'
                }}>
                    {currentTime.format("A")}
                </span>

            </div>
        );

        if (techData.getIn(['techs', userId, 'statusLoading'])) {
            dialogBody = (
                <span>Updating...</span>
            );

            submitButton = null;
        }

        const actions = [(<RaisedButton
            key="ArrivalTimeCancel"
            label="Close"
            primary={false}
            onTouchTap={this.handleCancel} />), submitButton];

        return (
            <div>
                <Dialog
                    title="Set Arrival Time"
                    bodyStyle={{
                        padding: '0'
                    }}
                    actions={actions}
                    modal={true}
                    open={open}>
                    <div
                        style={{
                            paddingLeft: '24px',
                            fontSize: '20px'
                        }}>
                        {dialogBody}
                    </div>
                </Dialog>
            </div>
        );
    }
}

ArrivalTimeDialog.propTypes = {
    siteActions: PropTypes.object.isRequired,
    statusActions: PropTypes.object.isRequired,
    techData: PropTypes.object.isRequired,
    userId: PropTypes.string,
    workOrder: PropTypes.object,
    currentUserId: PropTypes.string
    //,isSelf: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        site: state.get('site'),
        workOrder: state.get('workOrder'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        siteActions: bindActionCreators(siteActions, dispatch),
        statusActions: bindActionCreators(statusActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalTimeDialog);



// WEBPACK FOOTER //
// ./src/components/work-order/ArrivalTimeDialog.js